import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BookingStore, InstallationsStore } from '@store';

@Component({
  selector: 'app-booking-overview-commercial',
  templateUrl: './booking-overview-commercial.component.html',
  styleUrls: ['./booking-overview-commercial.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingOverviewCommercialComponent {
  constructor(public bookingStore: BookingStore, public installationsStore: InstallationsStore) {}
}
